import PropTypes from 'prop-types';
import React, { useEffect, forwardRef } from 'react';

import qrcodegen, { toSvgString, drawCanvas } from './qrcodegen-v1.8.0-es6';

const lightColor = '#ffffff';
const darkColor = '#000000';

function urlToSvgString(url) {
  const qr = qrcodegen.QrCode.encodeText(url, qrcodegen.QrCode.Ecc.LOW);
  const border = 4;

  return toSvgString(qr, border, lightColor, darkColor);
}

export function svgToDataUrl(svg) {
  if (!svg?.outerHTML) {
    return '';
  }
  return `data:image/svg+xml;charset=utf8,${encodeURIComponent(svg.outerHTML)}`;
}

const QrCodeSvg = forwardRef(({ url }, ref) => {
  const code = urlToSvgString(url);
  const viewBox = / viewBox="([^"]*)"/.exec(code)[1];
  const pathD = / d="([^"]*)"/.exec(code)[1];

  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox={viewBox} stroke="none">
      <rect width="100%" height="100%" fill={lightColor} />
      <path d={pathD} fill={darkColor} />
    </svg>
  );
});

QrCodeSvg.propTypes = {
  url: PropTypes.string.isRequired,
};

// the canvas ref should be used to generate downloadable URLs
// ref.current?.toDataURL('image/png')
const QrCodeCanvas = forwardRef(({ url }, ref) => {
  const border = 4;
  const scale = 5.0;
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;

    const qr = qrcodegen.QrCode.encodeText(url, qrcodegen.QrCode.Ecc.LOW);
    drawCanvas(qr, scale, border, lightColor, darkColor, canvas);
  }, [url]);

  return <canvas ref={ref} />;
});
QrCodeCanvas.propTypes = {
  url: PropTypes.string.isRequired,
};

export { QrCodeSvg, QrCodeCanvas };
